import React, { useState, useRef } from 'react'
import Dashboard from './Dashboard'
import AdminPanel from './AdminPanel'
import Settings from './Settings'
import Sidebar from './Sidebar'
import Cookies from "js-cookie";
import { Box } from '@mui/material'
import Header from '../../../components/Header'
import DashboardNew from './DashboardNew/Dashboard'
import DashboardSetting from './DashboardNew/components/DashboadSetting'
import CoachSettings from './CoachSettings'
import { tabList, accessMatrix } from '../../../config/roleAccessConfig';

const DashboardTabs = ({reload}) => {
  const [userData, setUserData] = useState(() => {
    const storedUser = Cookies.get("fytn_user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  // Dynamically filter tabs based on access
  const access = accessMatrix[userData?.userRole] || {};
  const tabConfig = tabList.filter(tab => access[tab.label]);
  // Set initial activeTab to the value of the first accessible tab
  const [activeTab, setActiveTab] = useState(tabConfig.length > 0 ? tabConfig[0].value : 0);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved ? JSON.parse(saved) : true; // Default to collapsed
  });
  const sidebarRef = useRef(null);

  const handleCollapseChange = (collapsed) => {
    setSidebarCollapsed(collapsed);
  };

  const handlePageClick = (e) => {
    // Only collapse if sidebar is expanded and click is not on sidebar
    if (!sidebarCollapsed && !e.target.closest('[data-sidebar]')) {
      if (sidebarRef.current) {
        sidebarRef.current.collapse();
      }
    }
  };

  let content = null;
  // Render content based on tab value
  if (userData?.userRole === 'ADMIN') {
    if (activeTab === 0) content = <DashboardNew reload={reload} userData={userData} />;
    else if (activeTab === 1) content = <Dashboard reload={reload} userData={userData} />;
    else if (activeTab === 2) content = <DashboardSetting />;
  } else {
    if (activeTab === 1) content = <Dashboard reload={reload} userData={userData} />;
    else if (activeTab === 2) content = <CoachSettings userData={userData} />;
  }
console.log("DashboardTabs component rendered with userData:", userData);
  return (
    <>
      <Header userName={userData?.userName} />
      <Box sx={{ marginTop: "5%", }}>
           <Sidebar 
             ref={sidebarRef}
             userRole={userData?.userRole} 
             activeTab={activeTab} 
             setActiveTab={setActiveTab}
             onCollapseChange={handleCollapseChange}
           />
    
        <Box 
          onClick={handlePageClick}
          sx={{ 
          paddingTop: "5px",
            ml: { xs: 0, md: "80px", lg: "80px" }, // Fixed margin for collapsed sidebar
            width: { xs: "100%", md: "calc(100% - 80px)", lg: "calc(100% - 80px)" }, // Fixed width
            px: { xs: 1, sm: 2 },
        }}>
          {content}
        </Box>
      </Box>
    </>
  )
}

export default DashboardTabs
